<template>
  <div class="header-wrapper">
    <div class="header-content">
      <div class="header-left">
          <img :src="en.logo" alt="">
      </div>
      <div class="header-right">
        <div class="header-right-content">
          <div class="header-right-content-text">
            <span>{{ MenuActive }}</span>
          </div>
          <div class="menu-icon" @click="toggleMenu">
            <img src="@/assets/h5/menu.png" alt="">
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="isMenuVisible" class="drawer-overlay" @click="toggleMenu"></div>
  <div :class="['drawer', { 'drawer-open': isMenuVisible }]">
    <div class="drawer-header">
      <span class="drawer-title">Menu</span>
      <div class="drawer-close" @click="toggleMenu">
        <img src="@/assets/h5/close.png" alt="Close">
      </div>
    </div>
    <div class="drawer-content">
      <div :class="['menu-item', { 'active': active === item.subjectName }]" @click="handleChange(item)" v-for="item in MenuList" :key="item.subjectId">
        <span>{{ item.showName }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue'
import en from '@/utils/en'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter()
const route = useRoute()
const MenuActive = ref("HOME")
onMounted(() => {
  active.value = route.name || "EnHome"
  MenuActive.value = MenuList.value.find(item => item.subjectName === active.value)?.showName
})
const active = ref("EnHome")
const handleChange = (item) => {
  active.value = item.subjectName
  MenuActive.value = item.showName
  router.push(item.path)
  toggleMenu()
}
const isMenuVisible = ref(false)

const MenuList = ref([
  {
    subjectId: 1,
    subjectName: 'EnHome',
    showName: 'HOME',
    path: '/en',
  },
  {
    subjectId: 2,
    subjectName: 'EnProgramme',
    showName: 'PROGRAMME',
    path: '/en/programme',
  },
  {
    subjectId: 3,
    subjectName: 'EnContact',
    showName: 'CONTACT',
    path: '/en/contact',
  },
])

const toggleMenu = () => {
  isMenuVisible.value = !isMenuVisible.value
}
</script>

<style scoped lang="less">
.header-wrapper {
  height: 60px;
  padding: 0 10px;
  border-bottom: 1px solid #f0f0f0;
}

.header-content {
  display: flex;
  justify-content: space-between;
  height: 100%;
  .header-left {
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    img {
      width: 50px;
    }
  }
  .header-right-content {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }
}

.menu-icon {
  margin-left: 10px;
  width: 30px;
  height: 30px;
}

.drawer-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  animation: fadeIn 0.3s ease;
}

.drawer {
  position: fixed;
  top: 0;
  right: -280px;
  width: 280px;
  height: 100vh;
  background: #ffffff;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 20px rgba(0, 0, 0, 0.15);
  transition: right 0.35s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;

  &.drawer-open {
    right: 0;
  }
}

.drawer-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  background: #fafafa;
}

.drawer-title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
}

.drawer-close {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background: #eeeeee;
  }

  img {
    width: 20px;
    height: 20px;
  }
}

.drawer-content {
  flex: 1;
  padding: 16px 0;
  overflow-y: auto;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 16px 24px;
  cursor: pointer;
  transition: background-color 0.2s ease, padding-left 0.2s ease;
  position: relative;

  &:hover {
    background: #f5f5f5;
    padding-left: 32px;

    &::before {
      opacity: 1;
      transform: scaleX(1);
    }
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%) scaleX(0);
    width: 4px;
    height: 24px;
    background: linear-gradient(180deg, #6366f1 0%, #8b5cf6 100%);
    border-radius: 0 2px 2px 0;
    transition: opacity 0.2s ease, transform 0.2s ease;
    opacity: 0;
  }

  span {
    font-size: 16px;
    color: #444444;
    font-weight: 500;
  }

  &.active {
    background: #00796C;
    padding-left: 32px;
    span {
      color: #ffffff;
      font-weight: 600;
    }
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
